import React, { Component } from "react";
import { connect } from "react-redux";
import "./index.css";
import SignInContainer from "../../components/containers/SignInContainer";
import { Row, Col, Card, Input, Button, PageHeader } from "antd";
import { AuthAction } from "../../store/actions";
import { FaUserCircle } from "react-icons/fa";
import { GrKey } from "react-icons/gr";
import BlackImage from "../../assets/images/black.jpg";
import StLogo from "../../assets/images/trkrLogo.png";
import LoaderGif from "../../assets/images/ie_loader.gif";
import UserIcon from "../../assets/images/User.png";
import UserIconOver from "../../assets/images/UserOver.png";
import KeyIcon from "../../assets/images/key.png";
import KeyIconOver from "../../assets/images/keyOver.png";
class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      emailError: "",
      passwordError: "",
    };
  }

  onHandleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      [`${e.target.name}Error`]: "",
      errorReducer: "",
    });
  };
  onSubmit = () => {
    const { email, password } = this.state;

    if (!email.length || !password.length) {
      if (!email.length) {
        this.setState({
          emailError: "Username required",
        });
      }
      if (!password.length) {
        this.setState({
          passwordError: "Password is required ",
        });
      }
      return;
    }
    this.props.signin({ email, password }, () =>
      this.props.history.push("/dashboard")
    );
  };
  componentDidUpdate(preProps, PreState) {
    if (preProps.error !== this.props.error && !this.props.loader) {
      this.setState({
        errorReducer: "Oops, thats not a match",
      });
    }
  }

  render() {
    const { signin, loader, error } = this.props;
    const { emailError, passwordError, errorReducer } = this.state;
    return (
      <SignInContainer>
        <Row justify="center" align="middle">
          <Col xl={14} lg={14} xs={22} sm={18} md={12}>
            <Row justify="center" gutter={[0, 40]} align="middle">
              <Col
                xl={24}
                lg={24}
                xs={24}
                sm={24}
                md={24}
                style={{ marginTop: "3rem" }}
              >
                <Card style={{ width: "100%" }}>
                  <Row gutter={[0, 15]} style={{ position: "relative" }}>
                    <Col
                      style={{
                        height: "155px",
                        borderRadius: "50%",
                        backgroundSize: "cover",
                        // backgroundPosition: "center center",
                        backgroundImage: `url(${StLogo})`,
                        position: "absolute",
                        top: "-90px",
                        right: 0,
                        left: "30%",
                        width: '155px'
                      }}
                    ></Col>
                    <Col span={24} style={{ marginTop: "5rem" }}>
                      <Row gutter={[0, 25]} justify="center">
                        <Col span={22}>
                          <Input
                            style={{
                              borderBottom: "1px solid gray",
                              padding: "10px",
                              fontSize: '1.1rem',
                              letterSpacing: '.5px',
                            }}
                            bordered={false}
                            size="25"
                            placeholder="USERNAME"
                            name="email"
                            onMouseOver={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: true,
                              });
                            }}
                            onMouseOut={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: false,
                              });
                            }}
                            onChange={this.onHandleChange}
                            prefix={
                              <img
                                src={
                                  !this.state["email_onHover"] ?
                                    UserIcon
                                    :
                                    UserIconOver
                                } />
                            }
                          />

                          <Row>
                            <Col span={24}>
                              <span className="text-right d-grid danger-color">
                                {emailError && emailError}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={22}>
                          <Input
                            style={{
                              borderBottom: "1px solid gray",
                              padding: "10px",
                              fontSize: '1.1rem',
                              letterSpacing: '.5px',
                            }}
                            bordered={false}
                            size="25"
                            placeholder="PASSWORD"
                            name="password"
                            type="password"
                            onChange={this.onHandleChange}
                            onMouseOver={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: true,
                              });
                            }}
                            onMouseOut={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: false,
                              });
                            }}
                            prefix={<img
                              src={
                                !this.state["password_onHover"] ?
                                  KeyIcon
                                  :
                                  KeyIconOver
                              } />}
                          />
                          <Row>
                            <Col span={24}>
                              <span
                                className={`text-right ${!errorReducer && "d-grid"
                                  } danger-color`}
                              >
                                {errorReducer && errorReducer}

                                {passwordError && passwordError}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={20}></Col>
                      </Row>
                    </Col>
                    <Col span={23}>
                      <Row
                        justify="end"
                        align="middle"
                        style={{ marginTop: "-1.7rem" }}
                      >
                        <Col span={24}>
                          <strong
                            className="pointer-cursor admin-forgot-psd navbar-font-family"
                            onClick={() =>
                              this.props.history.push("/forgot")
                            }
                            style={{
                              fontSize: "12px",
                              fontWeight: "bolder",
                              display: "flex",
                              justifyContent: "end",
                            }}
                          >
                            FORGOT PASSWORD?
                          </strong>
                        </Col>
                      </Row>
                      <Row justify="center">
                        <Col span={24} style={{ marginTop: "20px" }}>
                          <Button
                            style={{
                              backgroundColor: "#ff9800",
                              color: "#fff",
                              width: "50%",
                              letterSpacing: '.5px',
                              transition: '.2s ease-out(red)',
                              fontSize: '12px',
                            }}
                            onClick={this.onSubmit}
                          >
                            LOGIN
                          </Button>
                          {loader && (
                            <img src={LoaderGif} height={"60"} width={"60"} />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </Col>
              {/* <Col
                span={24}
                className="signinFormFooter"
                style={{
                  marginBottom: "3rem",
                  height: "auto",
                  paddingRight: "10px",
                  paddingLeft: "10px",
                  paddingTop: "15px",
                  paddingBottom: "10px",
                }}
              >
                <span style={{ color: "white" }}>
                  if you have don`t have a Username
                  <br />
                  <strong
                    className="pointer-cursor"
                    onClick={() => this.props.history.push("/register")}
                  >
                    Register here.
                  </strong>
                </span>
              </Col> */}
            </Row>
          </Col>
        </Row>
      </SignInContainer>
    );
  }
}

function mapStateToProps(storeState) {
  return {
    loader: storeState?.AuthReducer.loader,
    error: storeState?.AuthReducer.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    signin: (payload, cb, callback) => {
      dispatch(AuthAction.SignIn(payload, cb));
    },

    socialSignIn: (payload, cb) => {
      dispatch(AuthAction.SocialSignInReq(payload, cb));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
